import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { BarRating, BonusUi } from "../../../Constant";
import SimpleRatingBar from "./BarRating";
import StarRating from "./StarRating";
import ReverseRating from "./ReverseRating";
import IconsCount from "./IconsCount";
import ThumbsUp from "./ThumbsUp";
import CurrentRating from "./CurrentRating";

const RatingContainer = () => {
  return (
    <>
    <Breadcrumbs pageTitle={BarRating} parent={BonusUi} title={BarRating} />
    <Container fluid>
      <Row>
        <SimpleRatingBar />
        <StarRating/>
        <ReverseRating/>
        <ThumbsUp/>
        <IconsCount/>
        <CurrentRating/>
      </Row>
    </Container>
    </>
  )
};

export default RatingContainer;
